// Uses 'accordion-generic', 'accordion-group', 'accordion-group-expander' and 'accordion-group-expandable' classes.
// Can be used in menus and blocks

;(function ($) {
	'use strict';

	$(document).on('ready', function() {
		accordion_generic();
	});

	function accordion_generic() {
		$('.accordion-basic--expander').on('click',function() {
			let $this = $(this);
			let $group = $this.parents('.accordion-basic--group');
			let $expandable = $this.parents('.accordion-basic--group').find('.accordion-basic--expandable');

			$group.attr('aria-expanded', $group.attr('aria-expanded') === 'true' ? 'false' : 'true');
			$this.attr('aria-label', $this.attr('aria-label').includes('Open') ? $this.attr('aria-label').replace('Open', 'Close') : $this.attr('aria-label').replace('Close', 'Open'));
			$group.toggleClass('active');
			$expandable.slideToggle('300');
		});
	}
})(jQuery);
